import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import type { CopilotSettingsStore } from 'mini-copilot-types/lib/schema/SettingsStore.types';
import { type SettingFetchState } from 'mini-copilot-types/lib/schema/SettingsStore.types';

const defaultCopilotSettngsStore: CopilotSettingsStore = {
    isEnabled: false,
    licenses: [],
    featureInfo: new ObservableMap(),
    fetchState: 0,
    isProdigiEnabled: false,
};

export const CopilotSettingStore = createStore('CopilotSettingStore', defaultCopilotSettngsStore)();

export const getCopilotSettingStore = () => CopilotSettingStore;
